// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Form
//https://shopware-pwa-docs.vuestorefront.io/guide/CMS.html#block
const tData4 = {
    eMailAddress: "S.Guenther@GoetzGuenther.de",
    salutation: "Herr",
    Titel: "",
    Nachname: "Günther",
    Vorname: "Sebastian",
    Telefonnummer: "+49 371 77 41 46 0",
    Gruppe: "Mitglied",
    Verwaltungsbehörde: "AK-Berlin",
    Mitgliedsnummer: "00001"
};
const tData3 = {
    categories: [
        {
            name: "profile",
            displayName: "Mein Profil",
            properties: [
                {
                    name: "eMailAddress",
                    displayName: "E-Mail-Adresse (Benutzername)",
                    isReadOnly: true
                },
                {
                    name: "salutation",
                    displayName: "Anrede",
                    fieldType: "select",
                    attributes: {
                        itemSource: [
                            {
                                name: "Herr",
                                caption: "Herr"
                            },
                            {
                                name: "Frau",
                                caption: "Frau"
                            }
                        ],
                        valueExpr: "name",
                        displayExpr: "caption"
                    }
                },
                {
                    name: "Titel",
                    displayName: "Titel"
                },
                {
                    name: "Nachname",
                    displayName: "Nachname"
                },
                {
                    name: "Vorname",
                    displayName: "Vorname"
                },
                {
                    name: "Telefonnummer",
                    displayName: "Telefonnummer",
                    attributes: {
                        mode: "phone"
                    }
                },
                {
                    name: "Gruppe",
                    displayName: "Gruppe",
                    isReadOnly: true
                },
                {
                    name: "Verwaltungsbehörde",
                    displayName: "Verwaltungsbehörde",
                    isReadOnly: true
                },
                {
                    name: "Mitgliedsnummer",
                    displayName: "Mitgliedsnummer",
                    isReadOnly: true
                }
            ]
        },
        {
            name: "account",
            displayName: "Mein Account",
            properties: [
                {
                    name: "Name1",
                    displayName: "Name 1"
                },
                {
                    name: "Name2",
                    displayName: "Name 2"
                },
                {
                    name: "Name3",
                    displayName: "Name 3"
                },
                {
                    name: "street",
                    displayName: "Straße / Hausnummer"
                },
                {
                    name: "plz",
                    displayName: "Postleitzahl"
                },
                {
                    name: "ort",
                    displayName: "Ort"
                },
                {
                    name: "land",
                    displayName: "Land"
                },
                {
                    name: "Steuernummer",
                    displayName: "Steuernummer"
                },
                {
                    name: "EU-Ust.ID",
                    displayName: "EU-Ust.ID"
                },
            ]
        }
    ]
};
const tTicket = {
    name: 'test-456',
    type: 'container',
    itemNumber: "23-19992",
    matchcode: "Neue Anfrage per Facebook für Dämmmaterial",
    status: {
        key: "01",
        label: "Geschlossen",
        color: ""
    },
    headerProperties: [
        {
            "value": "Geschlossen",
            "mode": "badge",
            "options": {
                "style": "background-color: #DC3545"
            }
        },
        {
            "value": "Max Mustermann"
        },
        {
            "value": "IBS Workwear GmbH, Neukirchen"
        }
    ],
    detailProperties: [
        {
            "label": "Fälligkeit",
            "value": [
                {
                    "value": "08.06.2023 16:47:32",
                    "mode": "badge",
                    "options": {
                        "class": "bg-warning"
                    },
                }
            ]
        },
        {
            "label": "Kunde",
            "value": [
                {
                    "value": "IBS Workwear GmbH, Neukirchen"
                },
                {
                    "label": "Kto",
                    "value": "D112345"
                }
            ]
        },
        {
            "label": "Ansprechpartner",
            "value": [
                {
                    "label": "",
                    "value": "Schulz, Annett"
                },
                {
                    "label": "Telefon",
                    "value": "03432793660",
                    "mode": "telephone"
                },
                {
                    "label": "E-Mail",
                    "value": "info@waermerudolph.de",
                    "mode": "email"
                }
            ]
        },
        {
            "label": "Priorität",
            "value": "Nicht angegeben"
        },
        {
            "label": "Bearbeiter",
            "value": "@Hardware"
        },
        {
            "label": "Erstellt",
            "value": [
                {
                    "value": "Götz Günther"
                },
                {
                    "value": "08.06.2023 16:47:32"
                }
            ]
        }
    ],
    posts: [
        {
            userID: "U001",
            userName: "Sebastian Günther",
            message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.\n\rCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\rDonec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.Nulla consequat massa quis enim.\n\rDonec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.\n\rNullam dictum felis eu pede mollis pretium.Integer tincidunt.Cras dapibus.Vivamus elementum semper nisi.Aenean vulputate eleifend tellus.Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.Aliquam lorem ante, dapibus in, viverra quis, feugiat a,",
            timestamp: "2018-12-10T13:49:51.141Z"
        },
        {
            userID: "U001",
            userName: "Sebastian Günther",
            message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.\n\rCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\rDonec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.Nulla consequat massa quis enim.\n\rDonec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.\n\rNullam dictum felis eu pede mollis pretium.Integer tincidunt.Cras dapibus.Vivamus elementum semper nisi.Aenean vulputate eleifend tellus.Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.Aliquam lorem ante, dapibus in, viverra quis, feugiat a,",
            timestamp: "2018-12-10T13:49:51.141Z"
        },
        {
            userID: "U001",
            userName: "Sebastian Günther",
            message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.\n\rCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\rDonec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.Nulla consequat massa quis enim.\n\rDonec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.\n\rNullam dictum felis eu pede mollis pretium.Integer tincidunt.Cras dapibus.Vivamus elementum semper nisi.Aenean vulputate eleifend tellus.Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.Aliquam lorem ante, dapibus in, viverra quis, feugiat a,",
            timestamp: "2018-12-10T13:49:51.141Z",
            isActive: false,
        },
        {
            userID: "U001",
            userName: "Sebastian Günther",
            message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.\n\rCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\rDonec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.Nulla consequat massa quis enim.\n\rDonec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.\n\rNullam dictum felis eu pede mollis pretium.Integer tincidunt.Cras dapibus.Vivamus elementum semper nisi.Aenean vulputate eleifend tellus.Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.Aliquam lorem ante, dapibus in, viverra quis, feugiat a,",
            timestamp: "2018-12-10T13:49:51.141Z"
        },
        {
            userID: "U001",
            userName: "Sebastian Günther",
            message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.\n\rCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\rDonec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.Nulla consequat massa quis enim.\n\rDonec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.\n\rNullam dictum felis eu pede mollis pretium.Integer tincidunt.Cras dapibus.Vivamus elementum semper nisi.Aenean vulputate eleifend tellus.Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.Aliquam lorem ante, dapibus in, viverra quis, feugiat a,",
            timestamp: "2018-12-10T13:49:51.141Z"
        },
        {
            userID: "U001",
            userName: "Sebastian Günther",
            message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.\n\rCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\rDonec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.Nulla consequat massa quis enim.\n\rDonec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.\n\rNullam dictum felis eu pede mollis pretium.Integer tincidunt.Cras dapibus.Vivamus elementum semper nisi.Aenean vulputate eleifend tellus.Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.Aliquam lorem ante, dapibus in, viverra quis, feugiat a,",
            timestamp: "2018-12-10T13:49:51.141Z"
        },
        {
            userID: "U001",
            userName: "Sebastian Günther",
            message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.\n\rCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\rDonec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.Nulla consequat massa quis enim.\n\rDonec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.\n\rNullam dictum felis eu pede mollis pretium.Integer tincidunt.Cras dapibus.Vivamus elementum semper nisi.Aenean vulputate eleifend tellus.Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.Aliquam lorem ante, dapibus in, viverra quis, feugiat a,",
            timestamp: "2018-12-10T13:49:51.141Z"
        },
    ]
};
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-prototyp-page',
    // #endregion
    // #region Data
    data: () => ({
        _partID: '',
        _statusCode: 0,
        _content: tTicket,
        _schema: {},
        _data: {},
        _message: "",
        __scrollPosition: 0,
        __scrollEnd: false,
        __scrollEndHidden: false
    }),
    // #endregion
    // #region Constructor
    created() {
        host.api.get("identity/profile?mode=property").then(e => {
            this._schema = e.data.schema;
            this._data = e.data.data;
        });
    },
    // #endregion
    // #region Watch
    '$route.params.partID': function (value) {
        // #region Check
        if (utils.isNullOrEmpty(value)) {
            return;
        }
        // #endregion
        this._partID = value;
    },
    // #endregion
    // #region Core
    methods: {
        onPostScrolled() {
            var tElement = this.$refs["message"];
            this.__scrollPosition = tElement.scrollTop;
            this.__scrollEnd = tElement.offsetHeight + tElement.scrollTop >= tElement.scrollHeight;
            if (!this.__scrollEndHidden && this.__scrollEnd) {
                this.__scrollEndHidden = true;
            }
        },
        onCommand(args) {
            if (args.command === 'status_changed') {
                this._statusCode = args.statusCode;
            }
        },
        resize() {
            let element = this.$refs["textarea"];
            element.style.height = "18px";
            element.style.height = (element.scrollHeight > 210 ? 210 : element.scrollHeight) + "px";
        },
        scrollToPost(index) {
            setTimeout(function () {
                document?.getElementById('post-' + index)?.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        },
        scrollToEnd() {
            this.scrollToPost(this._content.posts.length - 1);
        },
        postMessage() {
            if (!this._message) {
                return;
            }
            this._content.posts.forEach((m) => {
                m.isActive = false;
            });
            this._content.posts.push({
                userID: "U001",
                userName: "Sebastian Günther",
                message: this._message,
                timestamp: new Date(),
                isActive: true
            });
            //Reset
            this._message = "";
            //Next
            nextTick(() => {
                this.resize();
                this.scrollToPost(this._content.posts.length - 1);
            });
        },
        showTicket() {
            this.$host.actions.tryExecute("288a.identity.account.edit", {}, { accountId: '49801877-45d5-42fe-8f50-1379bded9b93' });
            //this.$host.notification.showModal(this.$host.components.getComponent(""), { contextId: "WC-61-0001", itemId: "36CCSZWIS91FZ3VP" }, { size: "xlarge" });
        }
    }
    // #endregion
});
// #endregion
